import {
  NIL as NIL_UUID,
  v4 as uuidv4,
  validate as uuidValidate,
  version as uuidVersion
} from 'uuid'

const UUUID_V4 = 4
const emptyUuid = NIL_UUID
const newUuid = (option = null) => {
  return option ? uuidv4(option) : uuidv4()
}
const isUuid = (testVal) => {
  return uuidValidate(testVal) && uuidVersion(testVal) === UUUID_V4
}

export {
  emptyUuid,
  newUuid,
  isUuid
}
